import { BrowserModule } from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NO_ERRORS_SCHEMA, NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { NgxUiLoaderModule, NgxUiLoaderConfig } from 'ngx-ui-loader';
import { SplashScreenService } from './core/services/splash-screen.service';
import { AppComponent } from './app.component';
import { BackdropComponent } from './core/components/backdrop/backdrop.component';
import { ThemeConfigService } from './core/services/theme-config.service';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthGuardService } from './core/services/auth-guard.service';
import { GlobalHttpInterceptorService } from './core/services/global-http-interceptor.service';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { ToFixedPipe } from './content/pages/mes-ofa/features/details-ofa/round.pipe';
import { NgToggleModule } from 'ng-toggle-button';
import { DatePipe } from '@angular/common';
import { HistoriqueDetailsFormationComponent } from './content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-formation/historique-formation.component';
import { TableConfigService } from './content/pages/test/table-config.service';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { HistoriquesComponent } from './core/components/historiques/historiques.component';
import { Select2Module } from 'ng-select2-component';
import {AppConfigService} from "./core/services/config.service";
import {NgbTabsetModule} from "@ng-bootstrap/ng-bootstrap";

const maskConfig: Partial<IConfig> = {
  validation: false,
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = { };
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsSize: 60,
};

@NgModule({
  declarations: [
    AppComponent,
    HistoriquesComponent,
    HistoriqueDetailsFormationComponent,
    BackdropComponent,
    ToFixedPipe
  ],

  imports: [
    Select2Module,
    BrowserModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    AngularMultiSelectModule,
    NgxSpinnerModule,
    NgToggleModule,
    NgxMaskModule.forRoot(maskConfig),
    LoadingBarModule.forRoot(),
    TranslateModule.forRoot(),
    ToastrModule.forRoot(),
    NgxWebstorageModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgbTabsetModule,

  ],
  providers: [
    AppConfigService,
    DatePipe,
    TableConfigService,
    ThemeConfigService,
    SplashScreenService,
    AuthGuardService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  entryComponents: [
    HistoriqueDetailsFormationComponent,
    HistoriquesComponent
  ],

  bootstrap: [AppComponent],
})
export class AppModule {
}
